// ============================================
// Home Page Entry Point (index.html)
// ============================================

import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap';
import '@fortawesome/fontawesome-free/css/all.css';
import '../styles/custom.css';
import { initThemeToggle } from './themeToggle.js';

initThemeToggle();

console.log('FizzBuzz home page initialized');
